import { DataLoadingView } from "../../components";

export const View = () => {
  return (
    <div className="flex-container h-100 w-100 col justify-content--center align-items--center">
      <DataLoadingView message="Transaction processing..." />
    </div>
  );
};
